import Vue from 'vue';
import AppConfig from '@/app.config';
// import { encrypt, decrypt } from '@/plugins/helpers';

const { API_HOST } = AppConfig;

/* eslint-disable camelcase */

export default {
  app: {
    captcha(params) {
      return Vue.axios.get(`${API_HOST}/captcha`, { params });
    },
    version() {
      return Vue.axios.get(`${API_HOST}/version`);
    },
    currency() {
      return Vue.axios.get(`${API_HOST}/currency`);
    },
    async ipInfo() {
      // const key = 'ip-info';
      // if (localStorage.getItem(key)) {
      //   return decrypt(localStorage.getItem(key));
      // }
      const { data } = await Vue.axios.get(`${API_HOST}/ip-info`);
      // localStorage.setItem(key, encrypt(data));
      return Promise.resolve(data);
    },
  },
  ad: {
    get(position) {
      return Vue.axios.get(`${API_HOST}/ad`, { params: { position } });
    },
    put(id) {
      return Vue.axios.put(`${API_HOST}/ad/${id}`);
    },
  },
  config: {
    get() {
      return Vue.axios.get(`${API_HOST}/config`);
    },
  },
  sms: {
    send(params) {
      return Vue.axios.post(`${API_HOST}/send-sms`, params);
    },
    authenticate(params) {
      return Vue.axios.post(`${API_HOST}/sms-authenticate`, params);
    },
  },
  user: {
    register(params) {
      return Vue.axios.post(`${API_HOST}/register`, params);
    },
    authenticate(params) {
      return Vue.axios.post(`${API_HOST}/authenticate`, params);
    },
    wechatAuth() {
      return Vue.axios.get(`${API_HOST}/wechat-auth`);
    },
    shipbaoLogin(params) {
      return Vue.axios.post(`${API_HOST}/shipbao-login`, params);
    },
    identity() {
      return Vue.axios.get(`${API_HOST}/identity`);
    },
    resendActivationMail(email) {
      return Vue.axios.post(`${API_HOST}/resend-activation-mail`, { email });
    },
    activation(code) {
      return Vue.axios.post(`${API_HOST}/activation`, { code });
    },
    bindPlatform(code) {
      return Vue.axios.post(`${API_HOST}/bind-platform`, { code });
    },
    sendResetLink(email) {
      return Vue.axios.post(`${API_HOST}/send-reset-link`, { email });
    },
    resetPassword(params) {
      return Vue.axios.post(`${API_HOST}/reset-password`, params);
    },
    refresh() {
      return Vue.axios.post(`${API_HOST}/refresh`);
    },
    districts() {
      return Vue.axios.get(`${API_HOST}/districts`);
    },
    updatePassword(params) {
      return Vue.axios.post(`${API_HOST}/update-password`, params);
    },
    uploadAvatar(params) {
      return Vue.axios.post(`${API_HOST}/upload-avatar`, params);
    },
    userInfo(params) {
      return Vue.axios.post(`${API_HOST}/user-info`, params);
    },
    viewLog(params) {
      return Vue.axios.post(`${API_HOST}/view-log`, params);
    },
    verifyPhone(params) {
      return Vue.axios.post(`${API_HOST}/verify-phone`, params);
    },
    // sendSms() {
    //   return Vue.axios.post(`${API_HOST}/send-sms`)
    // },
    adminLogin(params) {
      return Vue.axios.post(`${API_HOST}/admin-login`, params);
    },
    creditCard() {
      return Vue.axios.get(`${API_HOST}/my-credit-card`);
    },
    prevShippingAddress() {
      return Vue.axios.get(`${API_HOST}/prev-shipping-address`);
    },
  },
  wishlist: {
    get() {
      return Vue.axios.get(`${API_HOST}/wishlist`);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/wishlist`, params);
    },
    delete(id) {
      return Vue.axios.delete(`${API_HOST}/wishlist/${id}`);
    },
  },
  brand: {
    get(params = {}) {
      return Vue.axios.get(`${API_HOST}/brand`, { params });
    },
  },
  product: {
    getOrginPlace() {
      return Vue.axios.get(`${API_HOST}/product-origin-place`);
    },
    get(params = {}) {
      return Vue.axios.get(`${API_HOST}/product`, { params });
    },
    getById(id, params = {}) {
      return Vue.axios.get(`${API_HOST}/product/${id}`, { params });
    },
    getViewLog() {
      return Vue.axios.get(`${API_HOST}/product-view-log`);
    },
    postViewLog(productId, time) {
      return Vue.axios.post(`${API_HOST}/product-view-log`, {
        product_id: productId,
        time: time || ~~(Date.now() / 1000),
      });
    },
    getCategories() {
      return Vue.axios.get(`${API_HOST}/product-categories`);
    },
    list() {
      return Vue.axios.get(`${API_HOST}/product-list`);
    },
    getComments(params = {}) {
      return Vue.axios.get(`${API_HOST}/product-comment`, { params });
    },
    postComments(params = {}) {
      return Vue.axios.post(`${API_HOST}/product-comment`, params);
    },
    getProductAdvisories(params = {}) {
      return Vue.axios.get(`${API_HOST}/product-advisory`, { params });
    },
    postProductAdvisory(params = {}) {
      return Vue.axios.post(`${API_HOST}/product-advisory`, params);
    },
    postProductArrival(params) {
      return Vue.axios.post(`${API_HOST}/product-arrival-notices`, params);
    },
    getCoupon(code) {
      return Vue.axios.post(`${API_HOST}/coupon?code=${code}`);
    },
    getCouponItem(id) {
      return Vue.axios.get(`${API_HOST}/coupon/${id}`);
    },
    getCouponList() {
      return Vue.axios.get(`${API_HOST}/coupon`);
    },
  },
  information: {
    get(name) {
      return Vue.axios.get(`${API_HOST}/information`, { params: { name } });
    },
  },
  history: {
    get() {
      return Vue.axios.get(`${API_HOST}/product-view-log`);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/product-view-log`, params);
    },
  },
  order: {
    get() {
      return Vue.axios.get(`${API_HOST}/order`);
    },
    getById(id) {
      return Vue.axios.get(`${API_HOST}/order/${id}`);
    },
    redemptionRenter() {
      return Vue.axios.get(`${API_HOST}/redemption-center`);
    },
    // eslint-disable-next-line
    couriers(address_id, ids) {
      return Vue.axios.get(`${API_HOST}/courier`, { params: { address_id, ids } });
    },
    shippingFee(params = null) {
      return Vue.axios.get(`${API_HOST}/shipping-fee`, { params });
    },
    submit(params) {
      return Vue.axios.post(`${API_HOST}/order`, params);
    },
    update(id, params) {
      return Vue.axios.put(`${API_HOST}/order/${id}`, params);
    },
    delete(params) {
      return Vue.axios.delete(`${API_HOST}/order/${params.orderId}?restore=${params.restore}`);
    },
    checkout(params) {
      return Vue.axios.post(`${API_HOST}/checkout`, params);
    },
    tracking(id) {
      return Vue.axios.get(`${API_HOST}/order-tracking/${id}`);
    },
    buyAgain(id) {
      return Vue.axios.post(`${API_HOST}/buy-again`, { order_id: id });
    },
    getPath(id) {
      return Vue.axios.get(`${API_HOST}/order-tracking/${id}`);
    },
    orderCheck(orderID) {
      return Vue.axios.get(`${API_HOST}/order-check-pay/${orderID}`);
    },
  },
  shippingAddress: {
    get() {
      return Vue.axios.get(`${API_HOST}/shipping-address`);
    },
    getById(id) {
      return Vue.axios.get(`${API_HOST}/shipping-address/${id}`);
    },
    put(id, params) {
      return Vue.axios.put(`${API_HOST}/shipping-address/${id}`, params);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/shipping-address`, params);
    },
    delete(id) {
      return Vue.axios.delete(`${API_HOST}/shipping-address/${id}`);
    },
    setDefault(id) {
      return Vue.axios.post(`${API_HOST}/set-default-shipping-address`, { id });
    },
    getFee() {
      return Vue.axios.get(`${API_HOST}/shipping-fee`);
    },
  },
  article: {
    get(params = {}) {
      return Vue.axios.get(`${API_HOST}/article`, { params });
    },
    getId(id) {
      return Vue.axios.get(`${API_HOST}/article/${id}`);
    },
    getCategoryById(id) {
      return Vue.axios.get(`${API_HOST}/article-by-category/${id}`);
    },
  },
  articleCategory: {
    getId(id) {
      return Vue.axios.get(`${API_HOST}/article-category/${id}`);
    },
  },
  paypal: {
    create(params) {
      return Vue.axios.post(`${API_HOST}/paypal/create-payment`, params);
    },
    execute(params) {
      return Vue.axios.post(`${API_HOST}/paypal/execute-payment`, params);
    },
    cancel(params) {
      return Vue.axios.post(`${API_HOST}/paypal/cancel-payment`, params);
    },
    check(params) {
      return Vue.axios.post(`${API_HOST}/paypal/check-payment`, params);
    },
  },
  paypalv2: {
    create(params) {
      return Vue.axios.get(`${API_HOST}/paypal_checkout/create`, { params });
    },
    capture(orderID) {
      return Vue.axios.get(`${API_HOST}/paypal_checkout/capture/${orderID}`);
    },
    // cancel(params) {
    //   return Vue.axios.post(`${API_HOST}/paypal_checkout/cancel`, params);
    // },
    check(orderID) {
      return Vue.axios.get(`${API_HOST}/paypal_checkout/check-payment/${orderID}`);
    },
    orderCheck(orderID) {
      return Vue.axios.get(`${API_HOST}/order-check-pay/${orderID}`);
    },
  },
  alipay: {
    check(order_id) {
      return Vue.axios.get(`${API_HOST}/alipay/check/${order_id}`);
    },
    qrcode(order_id) {
      return Vue.axios.get(`${API_HOST}/alipay?order_id=${order_id}&qrcode`);
    },
    qrcodePhone(order_id) {
      return Vue.axios.get(`${API_HOST}/alipay/create?order_id=${order_id}`);
    },
  },
  wepay: {
    check(order_id) {
      return Vue.axios.get(`${API_HOST}/wepay/check-payment/${order_id}`);
    },
    makepay(order_id) {
      return Vue.axios.get(`${API_HOST}/wepay/create?order_id=${order_id}`);
    },
  },
  yuansferpay: {
    makepay(params = {}) {
      return Vue.axios.get(`${API_HOST}/yuansfer/create`, { params });
    },
    check(order_id) {
      return Vue.axios.get(`${API_HOST}/yuansfer/check/${order_id}`);
    },
  },
  qfpay: {
    makepay(params = {}) {
      return Vue.axios.get(`${API_HOST}/qf/create`, { params });
    },
    check(order_id) {
      return Vue.axios.get(`${API_HOST}/yuansfer/check/${order_id}`);
    },
  },
  braintree: {
    getClientToken(order_id) {
      return Vue.axios.get(`${API_HOST}/braintree/client-token/${order_id}`);
    },
  },
  cart: {
    get() {
      return Vue.axios.get(`${API_HOST}/cart`);
    },
    delete(id) {
      return Vue.axios.delete(`${API_HOST}/cart/${id}`);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/cart`, params);
    },
    put(id, quantity) {
      return Vue.axios.put(`${API_HOST}/cart/${id}`, { quantity });
    },
  },
  proxy: {
    get(params = {}) {
      return Vue.axios.get(`${API_HOST}/proxy-request`, { params });
    },
    getById(id, params = {}) {
      return Vue.axios.get(`${API_HOST}/proxy-request/${id}`, { params });
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/proxy-request`, params);
    },
    put(id, params) {
      return Vue.axios.post(`${API_HOST}/proxy-request/${id}`, params);
    },
    delete(id) {
      return Vue.axios.delete(`${API_HOST}/proxy-request/${id}`);
    },
  },
  rakuten: {
    getCategory(id) {
      return Vue.axios.get(`${API_HOST}/rakuten/category`, { params: { id } });
    },
    getRanking(params) {
      return Vue.axios.get(`${API_HOST}/rakuten/ranking`, { params });
    },
    getItem(itemCode) {
      return Vue.axios.get(`${API_HOST}/rakuten/item/${itemCode}`);
    },
    getItemsSearch(params) {
      return Vue.axios.get(`${API_HOST}/rakuten/itemsSearch/`, { params });
    },
  },
  thirdPartyShopCart: {
    get() {
      return Vue.axios.get(`${API_HOST}/third-party-shop-cart`);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/third-party-shop-cart`, params);
    },
    put(id, quantity) {
      return Vue.axios.put(`${API_HOST}/third-party-shop-cart/${id}`, { quantity });
    },
    delete(id) {
      return Vue.axios.delete(`${API_HOST}/third-party-shop-cart/${id}`);
    },
  },
  thirdPartyShopWishlist: {
    get() {
      return Vue.axios.get(`${API_HOST}/third-party-shop-wishlist`);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/third-party-shop-wishlist`, params);
    },
    delete(id) {
      return Vue.axios.delete(`${API_HOST}/third-party-shop-wishlist/${id}`);
    },
  },
  yahoo: {
    getCategory(id) {
      return Vue.axios.get(`${API_HOST}/yahoo/category`, { params: { id } });
    },
    getRanking(params) {
      return Vue.axios.get(`${API_HOST}/yahoo/ranking`, { params });
    },
    getItemsSearch(categoryId, params) {
      return Vue.axios.get(`${API_HOST}/yahoo/itemsSearch/${categoryId}`, { params });
    },
    getItem(itemCode) {
      return Vue.axios.get(`${API_HOST}/yahoo/itemLookup/${itemCode}`);
    },
  },
  amazon: {
    getCategory(id) {
      return Vue.axios.get(`${API_HOST}/amazon/category`, { params: { id } });
    },
    getItemsSearch(params) {
      return Vue.axios.get(`${API_HOST}/amazon/itemsSearch`, { params });
    },
    getItem(itemCode) {
      return Vue.axios.get(`${API_HOST}/amazon/itemLookup/${itemCode}`);
    },
  },
  faq: {
    get() {
      return Vue.axios.get(`${API_HOST}/faq`);
    },
    isItUseful(id, useful) {
      return Vue.axios.put(`${API_HOST}/faq/${id}`, { useful });
    },
  },
  parcel: {
    claim(params) {
      return Vue.axios.post(`${API_HOST}/transportation/parcel-claim`, params);
    },
    claimCancel(id) {
      return Vue.axios.delete(`${API_HOST}/transportation/parcel-claim/${id}`);
    },
    getClaims() {
      return Vue.axios.get(`${API_HOST}/transportation/parcel-claim`);
    },
    getParcels(params) {
      return Vue.axios.get(`${API_HOST}/transportation/parcel`, { params });
    },
    count() {
      return Vue.axios.get(`${API_HOST}/transportation/parcel-count`);
    },
    getParcelId(id) {
      return Vue.axios.get(`${API_HOST}/transportation/parcel/${id}`);
    },
    postActivePushParcel(params) {
      return Vue.axios.post(`${API_HOST}/transportation/active-push-parcel`, params);
    },
  },
  transportationOrder: {
    get(params) {
      return Vue.axios.get(`${API_HOST}/transportation/order`, { params });
    },
    getById(id) {
      return Vue.axios.get(`${API_HOST}/transportation/order/${id}`);
    },
    post(params) {
      return Vue.axios.post(`${API_HOST}/transportation/order`, params);
    },
    compute(ids) {
      return Vue.axios.get(`${API_HOST}/transportation/compute-order`, { params: { ids } });
    },
    orderCost(parcel_id) {
      return Vue.axios.get(`${API_HOST}/transportation/order-cost`, { params: { parcel_id } });
    },
    checkUnpaidOrder() {
      return Vue.axios.get(`${API_HOST}/transportation/check-unpaid-order`);
    },
  },
  warehouse: {
    get(params = {}) {
      return Vue.axios.get(`${API_HOST}/transportation/warehouse`, { params });
    },
    shippingTypes() {
      return Vue.axios.get(`${API_HOST}/transportation/shipping-type`);
    },
    redemptionCenter() {
      return Vue.axios.get(`${API_HOST}/transportation/redemption-center`);
    },
    overseas() {
      return Vue.axios.get(`${API_HOST}/transportation/overseas-warehouse`);
    },
  },
  keyword: {
    query(q, platform) {
      return Vue.axios.get(`${API_HOST}/keyword`, { params: { query: q, platform } });
    },
  },
};
